// Import JS files
require('bootstrap')
require('nestable2')
require('masonry-layout')
require('../bower_components/combodate/src/combodate.js')
require('lightbox2')

// STYLESHEETS
// Import vendor stylesheets
require('element-ui/lib/theme-default/index.css')
require('bootstrap/dist/css/bootstrap.min.css')
require("../bower_components/font-awesome/scss/font-awesome.scss")
require('lightbox2/dist/css/lightbox.min.css')
// require('nestable2/jquery.nestable.css')

// import main stylesheet
require("./sass/style.sass")


// WEBPACK FOOTER //
// ./src/_resources.js